const ACTIONS = {
    GET_DATA_ADMIN_NEWS_SUCCESS: 'GET_DATA_ADMIN_NEWS_SUCCESS',
    GET_DATA_ERROR: 'GET_DATA_ERROR',
    ADD_NEWS_SUCCESS: 'ADD_NEWS_SUCCESS',
    ADD_NEWS_ERROR: 'ADD_NEWS_ERROR',
    GET_COMPANY_SUCCESS: 'GET_COMPANY_SUCCESS',
    GET_COMPANY_ERROR: 'GET_COMPANY_ERROR',
    GET_DETAIL_NEWS_SUCCESS: 'GET_DETAIL_NEWS_SUCCESS',
    GET_DETAIL_NEWS_ERROR: 'GET_DETAIL_NEWS_ERROR',
    UPDATE_NEWS_SUCCESS: 'UPDATE_NEWS_SUCCESS',
    UPDATE_NEWS_ERROR: 'UPDATE_NEWS_ERROR',
    DELETE_NEWS_SUCCESS: 'DELETE_NEWS_SUCCESS',
    DELETE_NEWS_ERROR: 'DELETE_NEWS_ERROR',
};

const header = ['お知らせ内容', '配信先', '公開日時', '']
const dataAdminNews = []

for (let i = 0; i < 10; i++) {
    dataAdminNews.push(
        {
            item: [
                { text: '内容が入ります。内容が入ります。内容が入ります。内容が入ります。内容が入り...' },
                { text: '配信先, 配信先, 配信先, 配信先, 配信先, 配信先, '},
                { text: '2019/12/12 12:34' },
                {
                    action: [
                        '編集', '削除'
                    ]
                }
            ]
        }
    )
}

export default (state = { header, dataAdminNews }, action) => {
    switch (action.type) {
        case ACTIONS.GET_DATA_ADMIN_NEWS_SUCCESS:
            return {
                ...state,
                type: action.type,
                response: action.data.data,
                meta: action.data.meta
            };
        case ACTIONS.GET_DATA_ERROR:
            return {
                ...state,
                type: action.type,
                response: action.err,
            }
        case ACTIONS.GET_COMPANY_SUCCESS:
            return {
                ...state,
                type: action.type,
                listCompany: action.data,
            }
        case ACTIONS.ADD_NEWS_SUCCESS:
            return {
                ...state,
                statusAddNews : action.data,
                type: action.type,
                status: true
            }
        case ACTIONS.ADD_NEWS_ERROR:
            return {
                ...state,
                type: action.type,
                statusAddNews: Object.keys(action.data.errors).map((key) => {
                    return action.data.errors[key].join(', ');
                }),
                status: false
            }
        case ACTIONS.GET_DETAIL_NEWS_SUCCESS:
            return {
                ...state,
                type: action.type,
                detailNews: action.data
            }
        case ACTIONS.GET_DETAIL_NEWS_ERROR:
            return {
                ...state,
                detailNews: action.err
            }
        case ACTIONS.UPDATE_NEWS_SUCCESS:
            return {
                ...state,
                type: action.type,
                statusUpdate: action.data
            }
        case ACTIONS.UPDATE_NEWS_ERROR:
            return {
                ...state,
                type: action.type,
                statusUpdate: Object.keys(action.data.errors).map((key) => {
                    return action.data.errors[key].join(', ');
                }),
            }
        case ACTIONS.DELETE_NEWS_SUCCESS:
            return {
                ...state,
                type: action.type,
                statusDelete: action.data
            }
        case ACTIONS.DELETE_NEWS_ERROR:
            return {
                ...state,
                type: action.type,
                statusDelete: action.err
            }
        default:
            return state;
    }
};